<template>
  <div class="tab-content" :class="(!applyStatus.page.tab01.enable)?'app-lock':''">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="top"
      :show-message="false"
      :hide-required-asterisk="true"
    >
      <el-form-item label="temp" prop="package">
        <span slot="label">
          {{t_content('botApp.createModal.package')}}&nbsp;
          <el-tooltip
            :content="t_content('botApp.createModal.package.tooltip')"
            placement="bottom"
            effect="light"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </span>
        <el-input v-model="form.package"></el-input>
      </el-form-item>
      <el-form-item label="temp" prop="publishSecret">
        <span slot="label">
          {{t_content('botApp.createModal.publishSecret')}}&nbsp;
          <el-tooltip
            :content="t_content('botApp.createModal.publishSecret.tooltip')"
            placement="bottom"
            effect="light"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </span>
        <el-input v-model="form.publishSecret"></el-input>
      </el-form-item>

      <el-form-item label="temp" prop="tagIds">
        <template slot="label">
          <label>
            {{
              t_content('botApp.tab01.appTag')
            }}
          </label>
          <el-tooltip :content="t_content('botApp.tab01.appTag.tooltip')" placement="bottom" effect="light">
            <i class="el-icon-question"></i>
          </el-tooltip>
          <span class="hint">{{t_content('botApp.tab01.appTag.hint')}}</span>
        </template>
        <div v-for="n in [0,1]" :key="n">
          <el-cascader
            expand-trigger="hover"
            :options="tagOptions"
            v-model="casTagIds[n]"
            @change="(value) => handleChange(value, n)"
          ></el-cascader>
          <br>
        </div>
        <hr>
      </el-form-item>
      <el-form-item label="temp">
        <template slot="label">
          <label>{{t_content('botApp.tab01.customerService')}}</label>
        </template>
        <el-checkbox-group v-model="useUserInfo" style="display:inline-block">
          <el-checkbox @change="useDefault" :label="t_content('botApp.tab01.userInfo')" name="type"></el-checkbox>
        </el-checkbox-group>&nbsp;
        <el-tooltip placement="bottom" effect="light">
          <div slot="content">
            <span v-html="t_content('botApp.tab01.customerService.tooltip')"></span>
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="temp" prop="customerServiceMail">
        <template slot="label">
          <label>{{t_content('botApp.tab01.customerServiceMail')}}</label>
        </template>
        <el-input v-model="form.customerServiceMail" :class="(useUserInfo)?'input-lock':''"></el-input>
      </el-form-item>
      <el-form-item label="temp" prop="customerServicePhone">
        <template slot="label">
          <label>{{t_content('botApp.tab01.customerServicePhone')}}</label>
        </template>
        <el-input v-model="form.customerServicePhone" :class="(useUserInfo)?'input-lock':''"></el-input>
      </el-form-item>
      <el-form-item label="temp" prop="customerServiceWeb">
        <template slot="label">
          <label>{{t_content('botApp.tab01.customerServiceWeb')}}</label>
        </template>
        <el-input v-model="form.customerServiceWeb" :class="(useUserInfo)?'input-lock':''"></el-input>
      </el-form-item>
      <el-form-item label="temp" prop="customerServicePrivacyUrl">
        <template slot="label">
          <label>{{t_content('botApp.tab01.servicePrivacyUrl')}}</label>
           <el-tooltip :content="t_content('botApp.tab01.servicePrivacyUrl.tooltip')" placement="bottom" effect="light">
            <i class="el-icon-question"></i>
          </el-tooltip>
          <span class="hint">{{t_content('botApp.tab01.servicePrivacyUrl.hint')}}</span>
        </template>
        <el-input type="textarea" v-model="form.customerServicePrivacyUrl"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import api from '../../../api'
import apiConfig from '../../../api/apiConfig'
import _ from 'lodash'

export default {
    mounted () {
        this.$root.$on('langChanged', langCode => {
            this.pubTagOptions()
        })
        this.pubTagOptions()
        this.casTagIds = this.toCasTagIds(this.form.tagIds)
    },
    data () {
        let {
            contentType,
            isDefaultCustomerServiceSetting,
            customerServiceMail,
            customerServicePhone,
            customerServiceWeb,
            customerServicePrivacyUrl,
            tagIds,
            publishSecret
        } = this.appInfo
        const Package = this.appInfo.package
        return {
            form: {
                isDefaultCustomerServiceSetting,
                customerServiceMail,
                customerServicePhone,
                customerServiceWeb,
                customerServicePrivacyUrl,
                tagIds,
                // tagIds: [
                // {
                //     miboStoreGoodsTagId: 30,
                //     miboStoreGoodsTagChildId: 7
                // },
                // {
                //     miboStoreGoodsTagId: 32
                // }
                // ],
                package: Package,
                publishSecret
            },
            contentType,
            tagOptions: [],
            casTagIds: [],
            rules: {
                tagIds: [{ type: 'array', required: true, trigger: 'blur' }],
                customerServiceMail: [{ required: true, trigger: 'blur' }],
                customerServicePhone: [{ required: true, trigger: 'blur' }],
                customerServiceWeb: [{ required: true, trigger: 'blur' }],
                customerServicePrivacyUrl: [
                    { required: true, trigger: 'blur' }
                ],
                package: [{ required: true, trigger: 'blur' }],
                publishSecret: [{ required: true, trigger: 'blur' }]
            }
        }
    },
    props: ['appInfo', 'applyStatus'],
    methods: {
        t_content (tKey) {
            return this.$t(tKey, {
                contentType: this.$t(`botApp.${this.$store.state.contentType}`)
            })
        },
        handleChange (value, n) {
            this.casTagIds[n] = value
        },
        getDataFromChild () {
            this.form.tagIds = this.toTagIds(this.casTagIds)
            return this.form
        },
        pubTagOptions () {
            // const { title, message, status, publishAfterDate } = this
            let apiUri = ''
            // apiUri = 'developer/tag?contentType=application'
            apiUri = 'developer/tag?contentType=content&subContentType=story'
            // apiUri = 'developer/tag?contentType=content&subContentType=song'
            const apiCfg = apiConfig(apiUri)
            // let body = { ...this.form }

            api.request('get', apiCfg.path, null, null, apiCfg.headers)
                .then(response => {
                    let options = response.data.data.payload
                    this.tagOptions = this.convertOption(options)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        _subConverter (opts) {
            return _.map(opts, o => {
                return {
                    value: o.miboStoreGoodsTagId,
                    label: this.langLabel(o.i18n),
                    children: o.childTags
                }
            })
        },
        convertOption (opts) {
            let a = _.map(opts, o => {
                if (o.childTags.length > 0) {
                    o.childTags = this._subConverter(o.childTags)
                }
                let b = {
                    value: o.miboStoreGoodsTagId,
                    label: this.langLabel(o.i18n),
                    children: o.childTags
                }
                if (b.children.length === 0) {
                    delete b.children
                }
                return b
            })
            return a
        },
        langLabel (i18n) {
            let langCode = this.$root.$i18n.locale
            langCode = langCode === 'en' ? 'zh-CN' : langCode
            return _.find(i18n, n => n.langCode === langCode).title
        },
        useDefault (value) {
            if (value) {
                this.fillUserInfo()
            }
        },
        fillUserInfo () {
            // const { title, message, status, publishAfterDate } = this
            const apiUri = 'developer/customerService'
            const apiCfg = apiConfig(apiUri)
            // let body = { ...this.form }

            api.request('get', apiCfg.path, null, null, apiCfg.headers)
                .then(response => {
                    const [userInfo] = response.data.data.payload
                    this.form.customerServiceMail = userInfo.customerServiceMail
                    this.form.customerServicePhone =
                        userInfo.customerServicePhone
                    this.form.customerServiceWeb = userInfo.customerServiceWeb
                    // Object.assign(this.form, userInfo)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        toCasTagIds (opts) {
            let pOpts = _.map(opts, o => ({ ...o }))
            return _.map(pOpts, o => {
                return Object.values(o)
            })
        },
        toTagIds (opts) {
            let pOpts = _.map(opts, o => ({ ...o }))
            return _.map(pOpts, o => {
                let oProps = ['miboStoreGoodsTagId', 'miboStoreGoodsTagChildId']
                let obj = {}
                _.forEach(o, (value, key) => {
                    obj[oProps[key]] = value
                })
                return obj
            })
        }
    },
    computed: {
        useUserInfo: {
            get: function () {
                return this.form.isDefaultCustomerServiceSetting === 'Y'
            },
            set: function (newValue) {
                this.form.isDefaultCustomerServiceSetting = newValue ? 'Y' : 'N'
            }
        }
    }
}
</script>

<style lang="scss">
.input-lock {
    pointer-events: none;
    .el-input__inner {
        background-color: #eee;
    }
}
</style>
